import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-h5p-player-header',
  templateUrl: './h5p-player-header.component.html',
  styleUrls: ['./h5p-player-header.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,

  standalone: false,
})
export class H5PPlayerHeaderComponent implements OnInit {
  @Input() hasNext = false;
  @Input() hasPrevious = false;
  @Input() isLastActivity = false;
  @Input() adminPreview = false;
  @Input() isPreview = false;
  @Input() showCourseNavigation = false;
  @Input() courseTitle = '';
  @Input() learningPathId = '';
  @Input() courseId = '';
  @Input() isSkippable = false;
  @Output() next = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();
  @Output() skip = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}

  onNext(): void {
    this.next.emit();
  }

  onPrevious(): void {
    this.previous.emit();
  }

  onSkip(): void {
    this.skip.emit();
  }

  getQueryParams(): { [key: string]: boolean | string } {
    let queryParams = {};

    if (this.adminPreview) {
      queryParams = {
        adminPreview: true,
      };
    } else if (this.isPreview) {
      queryParams = {
        isPreview: true,
      };
    }

    if (this.learningPathId) {
      Object.assign(queryParams, { learningPathId: this.learningPathId });
    }

    return queryParams;
  }

  openUserback(): void {
    // @ts-ignore
    if (!Userback) {
      return;
    }

    // @ts-ignore
    Userback.open();
  }
}
